import React from 'react';

type Esito = {
  titolo: string;
  testo: string;
  suggerimento?: string;
  azione: string;
};

// Motivi emessi dal backend in /auth/google/callback (backend/src/auth.js).
const ESITI: Record<string, Esito> = {
  'sessione-scaduta': {
    titolo: 'Sessione di accesso scaduta',
    testo:
      'La richiesta di accesso non è più valida. Succede quando la pagina viene ricaricata, ' +
      'quando si torna indietro dopo il login, o quando si apre BOP da un collegamento salvato ' +
      'nei preferiti o nella cronologia.',
    suggerimento:
      'Riparti da qui: se l’errore si ripete, elimina i preferiti che puntano a un indirizzo ' +
      'contenente /auth/ e cancella i cookie del sito.',
    azione: 'Riprova ad accedere',
  },
  annullato: {
    titolo: 'Accesso annullato',
    testo: 'Hai chiuso o annullato la finestra di accesso Google prima di completare la procedura.',
    azione: 'Riprova ad accedere',
  },
  'dominio-non-autorizzato': {
    titolo: 'Account non autorizzato',
    testo:
      'L’account Google usato non appartiene a un dominio abilitato ad accedere a BOP. ' +
      'Verifica di aver scelto il tuo account aziendale.',
    suggerimento: 'Se il problema persiste, contatta l’amministratore del gestionale.',
    azione: 'Torna al login',
  },
  'errore-google': {
    titolo: 'Google ha rifiutato l’accesso',
    testo: 'Il servizio di autenticazione Google ha interrotto la procedura di accesso.',
    azione: 'Riprova ad accedere',
  },
  'errore-tecnico': {
    titolo: 'Accesso non riuscito',
    testo:
      'Si è verificato un errore durante l’accesso. Il problema è stato registrato nei log del sistema.',
    suggerimento: 'Se si ripete, segnalalo all’amministratore indicando l’ora del tentativo.',
    azione: 'Riprova ad accedere',
  },
};

export default function ErroreAccesso() {
  const params = new URLSearchParams(window.location.search);
  const motivo = params.get('motivo') || 'errore-tecnico';
  const esito = ESITI[motivo] || ESITI['errore-tecnico'];

  return (
    <div className="login-page bop-errore-accesso">
      <div className="login-bg" aria-hidden="true">
        <div className="login-bg__mesh" />
        <div className="login-bg__grid" />
      </div>

      <div className="login-form-panel">
        <div className="login-card">
          <div className="bop-errore-accesso__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3 L22 20 H2 Z" />
              <path d="M12 10v4" />
              <path d="M12 17.5v.01" />
            </svg>
          </div>

          <h1 className="login-title">{esito.titolo}</h1>
          <p className="login-subtitle">{esito.testo}</p>

          {esito.suggerimento && (
            <div className="bop-errore-accesso__hint">{esito.suggerimento}</div>
          )}

          <a href="/" className="login-google-btn bop-errore-accesso__action">
            {esito.azione}
          </a>
        </div>
      </div>
    </div>
  );
}
